import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Cookies from 'js-cookie';

import translationTH from './locales/th.json';
import translationEN from './locales/en.json';

const resources = {
  th: { translation: translationTH },
  en: { translation: translationEN },
};

if(!Cookies.get('cdp_i18n')){
  Cookies.set('cdp_i18n', 'th', { expires: 365 });
}

const savedLanguage = Cookies.get('cdp_i18n') || 'th';

i18next
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'th',
    interpolation: { escapeValue: false },
  });

export default i18next;